// Posters on the desktop home page. Every upcoming event and tournament the
// member can see gets one automatically; this file only adds to them. Dates
// use America/Dawson_Creek (UTC-7). A poster disappears once its date is past.
//
// - Picture: save it as public/posters/<slug>.webp, 640 × 178 px, then map
//   the event's or tournament's Airtable record id to its path in IMAGES.
// - Several tournaments on one poster: add them to COMBINED.
// - A date with no Airtable record, such as a deadline: add it to NOTICES.
// - A featured group shows first, as a large card. Its button waits until a
//   grouped tournament's Registration State is Open in Airtable.

export interface CombinedTournaments {
  title: string;
  /** Airtable record ids of the tournaments. */
  tournaments: string[];
  image?: string;
  /** Replaces the Tournaments page link and label. */
  link?: { href: string; label: string };
  feature?: {
    headline: string;
    body: string;
    /** Shown in place of the button until registration opens, e.g. "Nov 4". */
    opensOn: string;
  };
}

export interface Notice {
  title: string;
  /** YYYY-MM-DD. */
  on: string;
  /** HH:MM, 24-hour. Leave it out for an all-day notice. */
  time?: string;
  link?: { href: string; label: string };
  image?: string;
}

export const IMAGES: Record<string, string> = {
  rec7VaCYmhFy39g7H: '/posters/end-of-season-social.webp',
};

export const COMBINED: CombinedTournaments[] = [
  {
    title: 'FTLO Charity Tournament for Journey Home',
    tournaments: ['recfoIBM2XsdobnYE', 'rec3reawzAZIb7C57'],
    image: '/posters/charity-tournament-calendar.webp',
    link: { href: '/tournaments', label: 'Register a team' },
    feature: {
      headline: 'Play for a good cause',
      body: "Boba League is back with our FTLO Charity Tournament! This time, we're playing to support Journey Home Community and their work supporting refugee claimants.",
      opensOn: 'Nov 4',
    },
  },
];

export const NOTICES: Notice[] = [
  {
    title: 'Team photos due',
    on: '2026-10-25',
  },
  {
    title: 'Deadline for declaring subs for league tournament',
    on: '2026-10-26',
    time: '23:59',
  },
];
